// removed by extract-text-webpack-plugin
module.exports = {"send-update-container":"send-update__send-update-container__1YXVt","send-type-wrapper":"send-update__send-type-wrapper__3J0Qu","input-wrapper":"send-update__input-wrapper__30jqq","textArea-inner":"send-update__textArea-inner__3tvnQ","button-wrapper":"send-update__button-wrapper__24_lo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/HostOption/SendUpdate/send-update.scss
// module id = 1363
// module chunks = 1